import Ajax from '@/lib/ajax'

export default {
  getAll() {
    return Ajax.get('/api/productManagement/productAttribute/all')
  },
  deleteById(id: string | number) {
    return Ajax.delete(`/api/productManagement/productAttribute?id=${id}`)
  },
  edit(id: string | number, editData: any) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/productManagement/productAttribute/${id}`
      : '/api/productManagement/productAttribute'
    return Ajax[ajaxType](ajaxUrl, editData)
  },
  getDataById(id: string | number) {
    return Ajax.get(`/api/productManagement/productAttribute/${id}`)
  },
  getList(
    pageSize: number,
    currentPage: number,
    productAttributeCategoryId?: number | string
  ) {
    return Ajax.get('/api/productManagement/productAttribute', {
      params: {
        ProductAttributeCategoryId: productAttributeCategoryId,
        MaxResultCount: pageSize,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
      }
    })
  }
}
